import { createContext, useContext } from 'react';

/**
 * Whether the editor is mid-sync. Provided by EditAutomationTemplateContent so the toolbar controls
 * can disable themselves without the flag being threaded down as a `disabled` prop.
 */
export const EditorSyncStatusContext = createContext(false);

/** Returns true while a sync is in progress; the toolbar controls read it to disable themselves. */
export function useEditorSyncStatus(): boolean {
  return useContext(EditorSyncStatusContext);
}
